import React from "react";
import "./head.css";

export const Head = (props) => {
  return (
    <>
      <div className="head-p">
        <div className="title-p">
          <h1>{props.title}</h1>
        </div>
      </div>
    </>
  );
};

export default Head;
